module.exports = __webpack_public_path__ + "static/assets/ba6251cf89b7742cd2ce08d4bdb78dd3.png";